import { FC, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import useAppModal from 'hooks/useAppModal';
import useAppSelector from 'hooks/useAppSelector';
import { SCHEDULED_MESSAGE_EDIT_MODAL_ID } from './modal/edit/ScheduledMessagesEditModal.constants';
import useScheduledMessagesEditModal from './modal/edit/useScheduledMessagesEditModal';

const ScheduledMessagesModal: FC = () => {
  const { key } = useParams();
  const hasInit = useRef(false);
  const activeModals = useAppSelector((state) => state.modal.activeModals);
  const { closeModal } = useAppModal();
  const { openEditScheduledMessagesModal } = useScheduledMessagesEditModal();

  useEffect(() => {
    if (
      key &&
      !activeModals[SCHEDULED_MESSAGE_EDIT_MODAL_ID] &&
      !hasInit.current
    ) {
      openEditScheduledMessagesModal({ scheduledMessageUid: key });
      hasInit.current = true;
    }
  }, [key, activeModals, openEditScheduledMessagesModal]);

  useEffect(() => {
    return () => {
      if (hasInit.current) {
        closeModal(SCHEDULED_MESSAGE_EDIT_MODAL_ID);
        hasInit.current = false;
      }
    };
  }, [closeModal]);

  return null;
};

export default ScheduledMessagesModal;
